import { Hosts } from '.';

const hosts: Hosts = {
  CTL_AUTHENTICATOR_SERVER: 'https://aipf-auth-ctl.csg-dev.lunit.in',
  CTL_DATA_SERVER: 'https://aipf-data-ctl.csg-dev.lunit.in',
  CTL_IMAGE_SERVER: 'https://aipf-image-ctl.csg-dev.lunit.in',
  AIPF_PORTAL_DOMAIN: 'https://aipf.tig-dev.lunit.in',
};

export default hosts;
